import Constants from 'constants';
import connector from "../services/connect/hardRefreshConnector";
import logout from '../services/connect/logoutConnector';
import ExternalApiRequest from 'services/externalApiRequest';

const refreshToken = () => {
    return async dispatch => {
        await connector();
        dispatch({
            type: Constants.actions.REFRESH.USER_JWT_UPDATED,
            payload: {}
        });
    };
};

const replaceToken = (token) => {
    return dispatch => {
        logout();
        dispatch({
            type: Constants.actions.USERINFO.REPLACE_TOKEN,
            payload: token
        });
    };
}

const  saveErrors = (payload) => {
    try {
        return async dispatch => {
            const  options = {
                api: "errorLog",
                content: payload
            };
            await ExternalApiRequest(options);  
        }
    } catch (error) {
        console.log(error);
    }
};

export { refreshToken, replaceToken, saveErrors };
